<jb-hero-skeleton titleOnly="true"></jb-hero-skeleton>
<jb-list-skeleton></jb-list-skeleton>
<div class="bg-white min-h-10"></div>
